(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9146],{

/***/ 9222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ asText; }
});

;// CONCATENATED MODULE: ./src/components/Abstracts/Storyblok/as-text.ts
var convertNodeToText = function(richTextField) {
    var separator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : " ";
    var result = "";
    for(var i = 0; i < (richTextField === null || richTextField === void 0 ? void 0 : richTextField.length); i++){
        var ref;
        var ref1;
        var richTextContents = (ref1 = (ref = richTextField[i]) === null || ref === void 0 ? void 0 : ref.content) !== null && ref1 !== void 0 ? ref1 : null;
        if (richTextContents) {
            for(var j = 0, k = richTextContents === null || richTextContents === void 0 ? void 0 : richTextContents.length; j < k; j++){
                var currentRichTextContent = richTextContents[j];
                if ("text" in currentRichTextContent) {
                    result += (result ? separator : "") + (currentRichTextContent === null || currentRichTextContent === void 0 ? void 0 : currentRichTextContent.text);
                }
            }
        }
    }
    return result;
};

;// CONCATENATED MODULE: ./src/components/Abstracts/Storyblok/index.ts

var asText = function(structuredText) {
    if (Object.prototype.toString.call(structuredText === null || structuredText === void 0 ? void 0 : structuredText.content) !== "[object Array]") {
        // console.warn(
        //   `Rich text argument should be an Array. Received ${typeof structuredText}`,
        // )
        return null;
    }
    return convertNodeToText(structuredText === null || structuredText === void 0 ? void 0 : structuredText.content);
};



/***/ }),

/***/ 85869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19845);
/* harmony import */ var classnames_bind__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _types_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37444);
/* harmony import */ var _types_grid_preset__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31538);
/* harmony import */ var _types_text_preset__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95348);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96660);
/* harmony import */ var _components_Abstracts_Storyblok__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9222);
/* harmony import */ var _components_Form_Newsletter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14515);
/* harmony import */ var _components_UI_Image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51025);
/* harmony import */ var _providers_StyleProvider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60118);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(20178);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_9__);













var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_1___default().bind((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default()));
var IMAGE_SIZES = [
    {
        ratio: 1
    }
];
function PushNewsletter(param) {
    var className = param.className, image = param.image, title = param.title, subtitle = param.subtitle, gdprText = param.gdprText, gdprLabel = param.gdprLabel;
    var gridStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_8__/* .useStyle */ .X)({
        grid: _types_grid_preset__WEBPACK_IMPORTED_MODULE_3__/* .GlobalGridPreset.BASE_GRID */ .H.BASE_GRID
    });
    var titleStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_8__/* .useStyle */ .X)({
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_4__/* .GlobalTextPreset.TitleFluid34_56SangBleu */ .C.TitleFluid34_56SangBleu
    });
    var subtitleStyle = (0,_providers_StyleProvider__WEBPACK_IMPORTED_MODULE_8__/* .useStyle */ .X)({
        textPreset: _types_text_preset__WEBPACK_IMPORTED_MODULE_4__/* .GlobalTextPreset.Label12Grotesk */ .C.Label12Grotesk
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().PushNewsletter), className),
        children: [
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_UI_Image__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, image), {
                layout: "fill",
                objectFit: "cover",
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().image),
                sizesFromBreakpoints: IMAGE_SIZES
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().grid), gridStyle),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().top),
                        children: [
                            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().title), titleStyle),
                                children: (0,_components_Abstracts_Storyblok__WEBPACK_IMPORTED_MODULE_12__/* .asText */ .S)(title)
                            }),
                            subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: cx((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().subtitle), subtitleStyle),
                                children: (0,_components_Abstracts_Storyblok__WEBPACK_IMPORTED_MODULE_12__/* .asText */ .S)(subtitle)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().body),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Form_Newsletter__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().newsletter),
                            fromTag: _lib_constants__WEBPACK_IMPORTED_MODULE_5__/* .NEWSLETTER_TAGS.FOOTER */ .dQ.FOOTER,
                            theme: _types_colors__WEBPACK_IMPORTED_MODULE_2__/* .GlobalThemeColors.White */ .b.White,
                            gdprLabel: gdprLabel,
                            gdprText: gdprText
                        })
                    })
                ]
            })
        ]
    });
}
PushNewsletter.defaultProps = {};
/* harmony default export */ __webpack_exports__["default"] = (PushNewsletter);


/***/ }),

/***/ 20178:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PushNewsletter":"styles_PushNewsletter__DbWLF","image":"styles_image__1N1Mr","grid":"styles_grid__yMqNT","top":"styles_top__glp_Z","body":"styles_body__iDlWP","title":"styles_title__o7_Le","subtitle":"styles_subtitle__2sHSF"};

/***/ })

}]);